import { render, staticRenderFns } from "./Reasignacion.vue?vue&type=template&id=0c9cf2de&"
import script from "./Reasignacion.vue?vue&type=script&lang=js&"
export * from "./Reasignacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports